import React, { useState } from 'react';
import { QuoteFilters } from '../../../../app/models/Quote';

type Props = {
    filter: QuoteFilters;
    setFilter: (filter: QuoteFilters) => void;
};

const QuoteFilter = ({ filter, setFilter }: Props) => {
    const [localFilter, setLocalFilter] = useState<QuoteFilters>({ ...filter });

    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setLocalFilter({ ...localFilter, [e.target.name]: e.target.value });
    };

    const search = () => {
        setFilter({ ...localFilter, page: 1 });
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') search();
    };

    return (
        <div className="row">
            <div className="row">
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="quote_id">
                            Cotización
                        </label>
                        <input
                            title="Número"
                            type="number"
                            id="quote_id"
                            name="quote_id"
                            className="form-control form-control-sm"
                            value={localFilter.quote_id ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="client">
                            Cliente
                        </label>
                        <input
                            title="Cliente"
                            type="text"
                            id="client"
                            name="client"
                            className="form-control form-control-sm"
                            value={localFilter.client ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-4">
                        <label className="font-size-10 mb-1" htmlFor="quote_status">
                            Estatus
                        </label>
                        <select
                            id="quote_status"
                            name="quote_status"
                            className="form-control form-select-sm"
                            value={localFilter.quote_status ?? ''}
                            onChange={handlerInputFilter}
                        >
                            <option value="TODOS">TODOS</option>
                            <option value="PREPARACION">Preparacion</option>
                            <option value="REVISION_OPERACION">Revision operación</option>
                            <option value="REVISION_CLIENTE">Revision Cliente</option>
                            <option value="CONFIRMADA">Confirmada</option>
                            <option value="RECHAZADA">Rechazada</option>
                        </select>
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="start_date">
                            Desde
                        </label>
                        <input
                            type="date"
                            id="start_date"
                            name="start_date"
                            className="form-control form-control-sm"
                            value={localFilter.start_date ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="end_date">
                            Hasta
                        </label>
                        <input
                            type="date"
                            id="end_date"
                            name="end_date"
                            className="form-control form-control-sm"
                            value={localFilter.end_date ?? ''}
                            onChange={handlerInputFilter}
                            onKeyDown={handleKeyDown}
                        />
                    </div>
                </div>
                <div className="col-md-auto d-flex align-items-center">
                    <div className="mb-3 mt-3">
                        <button
                            className="btn btn-primary btn-sm"
                            onClick={search}
                        >
                            <i className="mdi mdi-magnify me-1" />
                            Buscar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuoteFilter;
